module.exports = __webpack_public_path__ + "img/logo_2.1ab9dc7b.png";